<template>
  <div>
    <input v-model="checked" type="checkbox" class="selectUser">
  </div>
</template>

<script>
export default {
  name: 'checkboxFiled',

  data() {
    return {
      checked: false,
    }
  },

  props: {
    change: Function,
    data: {},
    meta: Object
  },

  created() {
    let name = this.meta?.name ?? 'selectedAllCheckbox';

    window.Vue.$on(name, (val) => {
      this.checked = val;
    })
  },

  computed: {
    computedMeta() {
      if (this.meta?.id) {
        return this.meta?.id()
      }
    }
  },

  watch: {
    checked(n, o) {
      this.change(this.data, n)
    },
    computedMeta(val) {
      this.checked = !!(val && this.data && this.data.id && val === this.data.id);
    }
  }
}
</script>